import {flightSchedule} from "../Pages/FlightSchedulePage";

export var ModalWindowSignatureLS = {
    container: null,
    idOperation: null,
    type: null,
    init: function (idDiv) {
        ModalWindowSignatureLS.container = document.querySelector('#'+idDiv);
        if (!ModalWindowSignatureLS.container) {
            ModalWindowSignatureLS.container = document.createElement('div');
            ModalWindowSignatureLS.container.id = idDiv;
            ModalWindowSignatureLS.container.hidden = true;
            document.body.appendChild(ModalWindowSignatureLS.container);

            m.mount(ModalWindowSignatureLS.container, m.component(ModalViewSignatureLS, {title: ""}));
        }
    },
    open: function (idOperation, type, idDiv=null) {
        ModalWindowSignatureLS.idOperation = idOperation;
        ModalWindowSignatureLS.type = type;
        if(ModalWindowSignatureLS.container === null)
            ModalWindowSignatureLS.container = document.querySelector('#'+idDiv);
        if (ModalWindowSignatureLS.container) {
            ModalWindowSignatureLS.container.hidden = false;
            m.redraw.strategy("diff");
        }
    },
    close: function () {
        ModalWindowSignatureLS.container.hidden = true;
    }
};

var ModalViewSignatureLS = {
    view: function (ctrl, args) {
        return [m("div.dm-overlay[id='']", [
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal[style='border: 0; width: 100%; max-width: 54em; ']", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[style='padding-right: 20px;'][id='headerModalAccCard']", "Уведомление"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalWindowSignatureLS.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='text-align: center;']", [
                                        m("b[id='titleSignatureLS']", "E-Loadsheet не подписан КВС. Подтвердить время операции?")
                                    ]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m(".col-xs-6", [
                                            m("button.btn.btn-danger.btn-lg", {
                                                id: "CancelSignatureLS",
                                                onclick: function () {
                                                    ModalWindowSignatureLS.close();
                                                }
                                            }, "Отмена")
                                        ]),
                                        m(".col-xs-6", [
                                            m("button.btn.btn-success.btn-lg", {
                                                id: "СonfirmationSignatureLS",
                                                onclick: function () {
                                                    if(ModalWindowSignatureLS.idOperation != null) {
                                                        switch(ModalWindowSignatureLS.type) {
                                                            case 1:
                                                                flightSchedule.setOperationStartTime(ModalWindowSignatureLS.idOperation);
                                                                break;
                                                            case 2:
                                                                flightSchedule.setOperationEndTime(ModalWindowSignatureLS.idOperation);
                                                                break;
                                                            case 3:
                                                                flightSchedule.setOperationCommonTime(ModalWindowSignatureLS.idOperation);
                                                                break;
                                                        }
                                                    }
                                                    ModalWindowSignatureLS.close();
                                                }
                                            }, "Потвердить")
                                        ])
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        ])];
    }
};
